import * as React from 'react';
import { UserStatus } from './types';

export const UserContext = React.createContext({} as UserStatus);
